import { useFetchUsersActiveDataSourcesQuery } from "@biggeo/bg-server-lib/studio";
import { useDataGridOptions } from "@biggeo/bg-ui/lab";

import PurchasedDataView from "../views/PurchasedDataView";
import { useEffect } from "react";

const PurchasedDataContainer = ({
    reload,
}: {
    readonly reload: boolean;
}) => {
    const {
        filterSearchPaginateProps,
        dataGridFetchInputProps: { sortModel, ...rest },
    } = useDataGridOptions(20);

    const {
        queryReturn: { data, loading, refetch },
    } = useFetchUsersActiveDataSourcesQuery({
        variables: {
            input: rest,
        },
    });

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (reload) {
            refetch();
        }
    }, [reload]);

    return (
        <PurchasedDataView
            data={
                data?.fetchUsersActiveDataSources || {
                    activeDataSources: [],
                    count: 0,
                }
            }
            loading={loading}
            pagination={filterSearchPaginateProps}
        />
    );
};

export default PurchasedDataContainer;
